import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

export const agenticAiChatActiveAtom = atom<boolean>(false);

export const agenticAiChatAtom = atomWithReset<string>('');
